import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import './css/storyJourney.css';
import { time } from 'framer-motion';

const storyDatabase = {
  'emma-liam': {
    title: 'Emma & Liam',
    description: 'Beautiful memories of their first year.',
    gallery: [
    //   { type: 'image', url: 'https://i.pinimg.com/736x/75/9d/a6/759da6614dea5254762892bf6f488841.jpg', caption: 'Born Today' },
    //    { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/23/fb/60/23fb60500ab1cb0434daba61f741916d.mp4', caption: 'Laughing moment' },
    //   { type: 'image', url: 'https://i.pinimg.com/736x/ba/5b/06/ba5b06125c4b55730003712a134def9a.jpg', caption: 'Tiny fingers, big love' },
    //   { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/cb/2e/df/cb2edff737a49f6536b7f26bfe5b133c.mp4', caption: 'Playful giggle' },
      { type: 'image', url: 'https://i.pinimg.com/736x/0b/db/73/0bdb73027cdaaec23194dd9056ac574b.jpg', caption: 'Wrapped in love on day one.' },
      { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/1d/ff/8f/1dff8f9025dc9efa4ab0463c7900c111.mp4', caption: 'Cuddles and smiles' },
       { type: 'image', url: 'https://i.pinimg.com/736x/e5/7f/05/e57f0595382484673637adca96c0bf6d.jpg', caption: 'Cutest pose of the day!' },
       { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/9e/bb/27/9ebb27aeaae1dac95ce08e7f25816d46.mp4', caption: 'Discovering tiny toes' },
    ],
  },
  'abigail-wedding': {
    title: 'Abigail’s Wedding',
    description: 'Captured joyful moments.',
    gallery: [
      { type: 'image', url: 'https://i.pinimg.com/736x/98/51/5a/98515a4c737663636860f902db6571fb.jpg', caption: 'Elegant wedding decor' },
     { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/01/fa/08/01fa08fd7ed79d05a693f01b53ba489d.mp4', caption: 'Where love meets luxury' },
     { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/6f/b6/85/6fb685a76e9b62e0413956416950de78.mp4', caption: 'A fairytale setup under the stars' },
     { type: 'image', url: 'https://i.pinimg.com/736x/9a/ef/bf/9aefbf1650204f34da5af882be19dd8e.jpg', caption: 'Grace wrapped in couture – every bride dream' },

    ],
  },
  'Emily’s-graduction':{
    title: 'Emily’s Achievement',
    description: 'Captured joyful moments.',
    gallery: [
      { type: 'image', url: 'https://i.pinimg.com/736x/15/df/3d/15df3daffdd89de62f06f48883785ea2.jpg', caption: 'Elegant wedding decor' },
     { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/91/cd/b6/91cdb6162fa16b2fd611097bec538b10.mp4', caption: 'Where love meets luxury' },
    { type: 'image', url: 'https://i.pinimg.com/736x/5f/13/0b/5f130bfd986607bb209a4fd7e9feab7a.jpg', caption: 'Grace wrapped in couture – every bride dream' },
     { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/f2/e5/e3/f2e5e38eb7dbafffedb0eeee4ed3e0bb.mp4', caption: 'A fairytale setup under the stars' },
    ],
  },
  'mom-dad':{
    title: 'Mom & Dad’s 25th Anniversary',
    description: 'A timeless celebration of 25 years of love, laughter, and togetherness.',
    gallery: [
      { type: 'image', url: 'https://i.pinimg.com/736x/eb/53/39/eb5339ca1a50ccc5e6e413e7a68c1799.jpg', caption: 'Timeless elegance woven into every detail of their special day.' },
     { type: 'video', url: 'https://v1.pinimg.com/videos/mc/720p/bb/cc/57/bbcc57cfa5cb5a9592abc1a3b536017d.mp4', caption: 'A grand celebration of 25 years—where love met luxury.' },
    { type: 'image', url: 'https://i.pinimg.com/736x/76/08/95/76089594e37b7e66e2e9d7232de6530c.jpg', caption: 'Grace wrapped in couture – every bride dream' },
     { type: 'image', url: 'https://i.pinimg.com/736x/31/d7/4e/31d74ea339c74a0f073df95fea00e03b.jpg', caption: 'A magical night under the stars, crafted like a fairytale.' },
    ],
  }
};

const StoryJourney = () => {
  const { id } = useParams();
  const story = storyDatabase[id];
  const [lightboxItem, setLightboxItem] = useState(null);

  if (!story) return <p className="story-not-found">Story not found.</p>;

  return (
    <section className="story-container">
     <div className='mainbar'>
       <Link to="/" className="back-link">← Back to Stories</Link>
       <div className="logo">
          <img src="/assets/lifoura-04.png" className="logo-img" alt="Logo" />
        </div>
     </div>

      <div className="story-header">
        <h1>{story.title}</h1>
        <p>{story.description}</p>
      </div>

      <div className="gallery-grid">
        {story.gallery.map((item, index) => (
          <div
            className={`gallery-card ${item.type === 'image' ? 'image-card' : 'video-card'}`}
            key={index}
            onClick={() => setLightboxItem(item)}
          >
            {item.type === 'image' ? (
              <img src={item.url} alt={item.caption} />
            ) : (
              <video muted loop preload="metadata" autoPlay>
                <source src={item.url} type="video/mp4" />
              </video>
            )}
            <p className="caption">{item.caption}</p>
          </div>
        ))}
      </div>

      {lightboxItem && (
        <div className="lightbox" onClick={() => setLightboxItem(null)}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <button
              className="lightbox-close"
              onClick={() => setLightboxItem(null)}
              aria-label="Close"
            >
              ×
            </button>
            {lightboxItem.type === 'image' ? (
              <img src={lightboxItem.url} alt={lightboxItem.caption} />
            ) : (
              <video controls autoPlay>
                <source src={lightboxItem.url} type="video/mp4" />
              </video>
            )}
            <p className="lightbox-caption">{lightboxItem.caption}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default StoryJourney;
